(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-header-portefeuilles"] && !Shopify.designMode) return;
  try {
    
  if (!window.premiumHeaderMenuBound) {
    window.premiumHeaderMenuBound = true;
    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-premium-menu-close]');
      if (!closeButton) return;
      const menu = closeButton.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  }

  } catch(e) { console.error(e); }
})();
})();
